import { forwardRef } from 'react';
import { Toast } from 'devextreme-react';
import './BaseNotification.scss'


const BaseNotification = forwardRef((
    /**
     * @param { String } message: `The content to be displayed in the toast, long or short. 
     * Required. Defaults to "".`
     * @param { Function } setter: `Accepts a method that sets the new state of a react hook.
     * Optional. Defaults to null.`
     * @param { String } type: `The type or level of a toast being displayed (by color). 
     * Options are 'error' (red, with an X icon), 'info' (blue, in a bubble icon), 'success' 
     * (green, with a checkmark icon), and 'warning' (yellow, with exclamation mark icon).`
     * @param { Boolean } visible: Toggle the visiblity of the whole compoennt. Defaults 
     * to false .
     */
    {
        message,
        setter,
        type,
        visible
    },
    ref
) => {

    const handleToastFocusOnClose = (e) => {
        if (e.key === 'Escape' || e.key === 'Enter') {
            toastRef.current?.instance.hide();
            onClose?.();
        };
    };


    return (
        <Toast
            animation={{
                show: {
                    type: 'fade',
                    duration: 300,
                    from: 0,
                    to: 1
                },
                hide: {
                    type: 'fade',
                    duration: 300,
                    from: 1,
                    to: 0
                }
            }}
            closeOnClick={true}
            displayTime={86400000}
            focusStateEnabled={true}
            message={message}
            onShown={() => {
                const toastElement = ref.current?.instance.$element()?.get(0);
                if (toastElement) {
                    toastElement.focus();
                    toastElement.addEventListener('keydown', handleToastFocusOnClose);
                };
            }} 
            onHiding={() => {
                const toastElement = ref.current?.instance?.$element()?.get(0);
                if (toastElement) {
                    toastElement.removeEventListener('keydown', handleToastFocusOnClose)
                };
                setter();
            }}
            ref={ref}
            type={type}
            visible={visible}
        />
    );
});

export default BaseNotification;